import { ArrowUpRight, MapPin } from "lucide-react";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-12 md:pb-20 grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* top meta row */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-10 md:mb-16">
          <div className="flex items-center gap-3 text-xs md:text-sm text-[color:var(--ink-2)]">
            <span className="chip" data-testid="hero-location-chip">
              <MapPin className="w-3.5 h-3.5" />
              Based in Mumbai · Serving India
            </span>
          </div>
        </div>

        {/* headline */}
        <div className="grid grid-cols-12 gap-y-10">
          <div className="col-span-12 md:col-span-9">
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="bigword text-[14vw] md:text-[10.5vw] lg:text-[8.5vw] text-balance"
              data-testid="hero-headline"
            >
              Build.{" "}
              <span className="font-serif-accent font-normal italic tracking-tight">
                Automate.
              </span>{" "}
              <span className="underline-fancy">Grow.</span>
            </motion.h1>
          </div>

          <div className="col-span-12 md:col-start-8 md:col-span-5 -mt-4 md:-mt-10">
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
              className="text-base md:text-lg leading-relaxed text-[color:var(--ink-2)] max-w-xl"
              data-testid="hero-subhead"
            >
              CyberCart is a digital growth & automation agency offering website development, WooCommerce stores, SEO services, lead generation, CRM setup, WhatsApp automation, and AI workflows. Serving businesses across India — Build. Automate. Grow.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3, ease: "easeOut" }}
              className="mt-7 flex flex-wrap items-center gap-3"
            >
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="btn-primary"
              >
                Book a free strategy call
                <ArrowUpRight className="w-4 h-4" />
              </a>
              <a
                href="#services"
                data-testid="hero-cta-secondary"
                className="btn-ghost"
              >
                See our services
              </a>
            </motion.div>

            <div className="mt-8 flex items-center gap-3 text-xs text-[color:var(--ink-2)]">
              <span className="dot" /> No pitch decks. A 30-min call. A free
              audit of your funnel.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
